import { Button, ButtonGroup, Divider, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { Form, Modal } from "components";
import { API } from "config";
import { useOrder } from "hooks";
import { useState } from "react";
import { Authenticate } from "screens";

export default function SetShipping({ data, ...props }){

    const toast = useToast()
    const order = useOrder(data?.id)
    const [ loading, setLoading ] = useState(false)
    const [ shipping_type, setShipping ] = useState()
    const auth = useDisclosure()

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.post(`/orders/${order.data?.id}`, { shipping_type, _method: 'put' })
            toast({ title: 'Tipo de envio alterado!' })
            order.refetch()
            props?.onClose()
        }catch(err){
            toast({ title: 'Não foi possível alterar o tipo de envio. Tente novamente.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Modal title="Alterar forma de envio do pedido" {...props}>
        <ModalBody>
            <Stack spacing={4}>
                <Text fontSize="sm">Você está prestes a alterar o tipo de envio do pedido. Tenha em mente que só é aconselhável fazer isso em pedidos que estão com o status "Aprovado" ou "Em Análise".</Text>

                <Divider />

                <Form.Select
                    label="Selecione o tipo de envio:"
                    options={[{ label: 'Para envio', value: 1 }, { label: 'Para retirada', value: 2 }]}
                    onChange={e => setShipping(e.target.value)}
                />
            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={order.isFetching || !!loading}>
                <Button colorScheme="orange" isLoading={loading} isDisabled={!shipping_type} onClick={auth.onOpen}>Alterar tipo de envio</Button>
                <Button onClick={props?.onClose}>Fechar</Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}